import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router, Resolve } from '@angular/router';
import { DataService } from '../services/data.service';
import { GeneralService } from 'src/app/services/general.service';
import { Unidad } from 'src/app/models/unidad';
import { Util } from '../utils/functions';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class UnidadGuard implements Resolve<any>  {

  parametros: any;
  unidades: any;
  unidadSelected: Unidad;
  url: string = '';

  constructor(
    private generalService: GeneralService,
    private dataService: DataService,
    private router: Router,
    @Inject(PLATFORM_ID) public platformId: Object

  ) { }

  async resolve(next: ActivatedRouteSnapshot): Promise<any> {

      if (isPlatformBrowser(this.platformId)) {
        this.dataService.currentParametros.subscribe(parametros => this.parametros = parametros)
        this.dataService.currentUnidades.subscribe(unidades => this.unidades = unidades);
        this.dataService.currentUnidadSelected.subscribe(unidadSelected => this.unidadSelected = unidadSelected)
        this.dataService.currentUrl.subscribe(url => this.url = url)
  
        if (((this.parametros === null || this.parametros === '') && this.unidades.length === 0) ||
          this.unidadSelected.idUnidad === 0) {
          const parameter = await this.generalService.parametros();
          const unit = await this.generalService.unidades(1);
  
          if (parameter['codigo'] === 1 && unit['codigo'] === 1) {
            this.dataService.changeParametros(parameter['data']);
            this.dataService.changeUnidades(unit['data']);
            const unidadURL = Util.eliminarDiacriticos(next.params.unidad.toLowerCase().replace(/[' ']+/g, '-')); // Unidad recuperada ActivatedRouteSnapshot
  
            const unidadSelected = unit['data'].filter(unidad => {
              return unidadURL == Util.eliminarDiacriticos(unidad.nombre.toLowerCase().replace(/[' ']+/g, '-'));
            })
  
            this.dataService.changeUnidadSelected(unidadSelected[0]);
            return true
          } else {
            this.router.navigate(['home']);
            return true
          }
        } else {
          return true
        }
      }
  
  }
}
